export default __webpack_public_path__ + "11c7b4e7905f498d80a406335836c490.svg";